module.exports = __webpack_public_path__ + "static/media/victory1.e554e242.mp3";